import { GET, POST } from "../../../module/services/fetch";
import { map } from "rxjs/operators";

export const fetchTypeRequest = () =>
  GET(`request/service/all`).pipe(map((response: any) => response));

export const fetchFieldRequest = (idServiceRequest: number) =>
  GET(`request/service/fields/${idServiceRequest}`).pipe(
    map((response: any) => response)
  );

export const sendServiceRequest = (obj: FormData) =>
  POST(
    "request/createRequests",
    obj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const sendNewApiServiceRequest = (obj: FormData) =>
  POST(
    "request/service/create",
    obj,
    undefined,
    undefined,
    undefined,
    "multipart/form-data"
  ).pipe(map((response: any) => response));

export const fetchBAORequest = () => {
  const req = {
    userType: "Employee",
  };
  //w1 - Project Metro
  return POST("service-request/user/find", req).pipe(map((response: any) => response));
};

export const fetchApplicationsRequest = () => {
  return POST("application/find").pipe(map((response: any) => response));
};
